import React, { useEffect, useState } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import EditorPage from "./pages/EditorPage";

export default function App() {

  const [blogId, setBlogId] = useState(12345);
  const [mode, setMode] = useState("create");

  useEffect(() => {

    const hash = window.location.hash;  
    const queryString = hash.split("?")[1] || "";

    const params = new URLSearchParams(queryString);

    const bId = params.get("blog_id");
    const m = params.get("mode");

    if (bId) {
      setBlogId(bId);
    }

    if (m) {
      setMode(m);
    }

  }, []);

  return (
    <HashRouter>
      <Routes>
        {blogId && (
          <Route 
            path="/*"           // <-- MATCH EVERYTHING
            element={<EditorPage blogId={blogId} mode={mode} />} 
          />
        )}
      </Routes>
    </HashRouter>
  );
}
